import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Heading from 'components/shared/heading';
import styles from './styles.module.scss';

// Tags arrive from WP as a comma-separated string (e.g. "tag1,tag2, tag3") — a simple
// author-editable list, no nested repeater needed. Split on commas and trim each tag.
// Tolerate an array as a fallback.
const splitTags = (value) => {
  if (Array.isArray(value)) return value.map((v) => String(v).trim()).filter(Boolean);
  if (typeof value === 'string') {
    return value
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
  }
  return [];
};

const IntegrationsRow = ({
  eyebrow = '',
  title = null,
  description = '',
  tags = '',
  closingText = '',
  theme = '',
}) => {
  const tagList = splitTags(tags);

  if (!title && tagList.length === 0) {
    return null;
  }

  return (
    <section
      className={cn(styles.root, {
        [styles.themeLight]: theme === 'light',
        [styles.themeDark]: theme === 'dark',
      })}
    >
      <div className="container">
        {(eyebrow || title || description) && (
          <div className={styles.header}>
            {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
            {title && <Heading tag="h2" size="xl" className={styles.title} innerHTML={title} />}
            {description && (
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
          </div>
        )}

        {tagList.length > 0 && (
          <ul className={styles.chips}>
            {tagList.map((tag, index) => (
              <li key={index} className={styles.chip}>
                <span className={styles.dot} aria-hidden="true" />
                {tag}
              </li>
            ))}
          </ul>
        )}

        {closingText && (
          <div className={styles.closing} dangerouslySetInnerHTML={{ __html: closingText }} />
        )}
      </div>
    </section>
  );
};

IntegrationsRow.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.string, // HTML; wrap words in <span>/<strong> to color them
  description: PropTypes.string,
  tags: PropTypes.oneOfType([PropTypes.string, PropTypes.array]), // comma-separated, e.g. "tag1,tag2, tag3"
  closingText: PropTypes.string, // HTML; supports a <br> for the two-line statement
  theme: PropTypes.oneOf(['', 'light', 'dark']),
};

export default IntegrationsRow;
